/** WS8 aliases for the generated API schema (the only source of shapes). */
import type { Schemas } from "../api/client";

export type Timeline = Schemas["Timeline"];
export type TimelineLine = Schemas["TimelineLine"];
export type TimelineWord = Schemas["TimelineWord"];
export type TimelineSection = Schemas["TimelineSection"];
export type HeatBin = Schemas["HeatBin"];
export type HotWindow = Schemas["HotWindowMv"];
export type Segment = Schemas["Segment"];
export type Cutscene = Schemas["Cutscene"];
export type Suggestion = Schemas["SuggestionOut"];
export type ClipOut = Schemas["ClipOut"];
/** A clip of a music video (the Watch timeline lists only these): video_id and the MV window are always set. */
export type MvClipOut = Schemas["MvClipOut"];
export type ClipDetail = Schemas["ClipDetail"];
export type ClipIn = Schemas["ClipIn"];
export type ClipPatch = Schemas["ClipPatch"];
export type ClipState = Schemas["ClipState"];
export type TemplateState = Schemas["TemplateState"];
export type TemplateOption = Schemas["TemplateOption"];
export type TemplateOut = Schemas["TemplateOut"];
export type RenderOut = Schemas["RenderOut"];
export type RenderDetail = Schemas["RenderDetail"];
export type VerdictOut = Schemas["VerdictOut"];
export type QaCategory = Schemas["QaCategory"];
export type WorkNext = Schemas["WorkNext"];
export type WorkItem = Schemas["WorkItemOut"];
export type MediaOut = Schemas["MediaOut"];
export type StepOut = Schemas["StepOut"];
export type BoardPage = Schemas["BoardPage"];
export type LyricsOut = Schemas["LyricsOut"];
export type SceneMv = Schemas["SceneMv"];
export type SceneStats = Schemas["SceneStats"];
export type ClipLimits = Schemas["ClipLimits"];
export type ParamSpec = Schemas["ParamSpec"];
export type PresetOut = Schemas["PresetOut"];
export type TryOut = Schemas["TryOut"];

/** QA categories in display order, with the key that selects each one on the Render page. */
export const QA_CATEGORIES: readonly { id: QaCategory; label: string; key: string }[] = [
  { id: "no_errors", label: "No errors (approve)", key: "1" },
  { id: "bad_timing", label: "Bad timing", key: "2" },
  { id: "wrong_canvas_position", label: "Wrong canvas position", key: "3" },
  { id: "face_cropped", label: "Face cropped", key: "4" },
  { id: "caption_stack", label: "Caption stack", key: "5" },
  { id: "audio_issue", label: "Audio issue", key: "6" },
  { id: "duplicate", label: "Duplicate", key: "7" },
  { id: "off_brand", label: "Off brand", key: "8" },
  { id: "wrong_lyrics", label: "Wrong lyrics", key: "9" },
  { id: "visual_glitch", label: "Visual glitch", key: "0" },
  { id: "other", label: "Other", key: "-" },
];

/** Compile-time check that every QaCategory has a button. */
const _qaComplete: Record<QaCategory, true> = {
  no_errors: true, bad_timing: true, wrong_canvas_position: true, face_cropped: true, caption_stack: true,
  audio_issue: true, duplicate: true, off_brand: true, wrong_lyrics: true, visual_glitch: true, other: true,
};
export const QA_CATEGORY_COUNT = Object.keys(_qaComplete).length;

export function qaLabel(c: QaCategory | null | undefined): string {
  if (!c) return "not reviewed";
  return QA_CATEGORIES.find((q) => q.id === c)?.label ?? c;
}
